import { CheckCircle2, XCircle } from 'lucide-react';

export const getStatusColor = (status) => {
  const colors = {
    active: 'bg-green-500/10 text-green-600 dark:text-green-400',
    inactive: 'bg-gray-500/10 text-gray-600 dark:text-gray-400',
    suspended: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
    blocked: 'bg-red-500/10 text-red-600 dark:text-red-400',
    deleted: 'bg-red-500/10 text-red-600 dark:text-red-400',
    pending: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
    under_review: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
    approved: 'bg-green-500/10 text-green-600 dark:text-green-400',
    rejected: 'bg-red-500/10 text-red-600 dark:text-red-400',
    expired: 'bg-orange-500/10 text-orange-600 dark:text-orange-400',
    verified: 'bg-green-500/10 text-green-600 dark:text-green-400',
  };
  return colors[status] || 'bg-gray-500/10 text-gray-600 dark:text-gray-400';
};

export const getVerificationStatus = (isVerified) => {
  return isVerified ? (
    <span className='inline-flex items-center px-2 py-1 text-xs font-medium rounded-full bg-green-500/10 text-green-600 dark:text-green-400'>
      <CheckCircle2 size={14} className='mr-1' />
      Verified
    </span>
  ) : (
    <span className='inline-flex items-center px-2 py-1 text-xs font-medium rounded-full bg-gray-500/10 text-gray-600 dark:text-gray-400'>
      <XCircle size={14} className='mr-1' />
      Not Verified
    </span>
  );
};
